export const optionsTime = {
    weekday: "long",
    year: "numeric",
    month: "long",
    day: "numeric",
    hour: "numeric",
    hour12: "false",
    minute: "numeric",
    second: "numeric",
  };